<template>
  <div id="app" :class="{'windows-aio':isWindowsAio}" :style="styleObject">
    <index-head>
      <router-view name="head"></router-view>
    </index-head>
    <content-page>
      <router-view></router-view>
    </content-page>
    <index-footer v-if="$route.name!=='index'"></index-footer>
    <zoom-img></zoom-img>
  </div>
</template>

<script>
  import indexHead from './views/common/head.vue';
  import contentPage from './views/common/content.vue'
  import indexFooter from './views/common/footer.vue'
  import zoomImg from '@/components/composite/zoomImg'
  import utils from './utils/index.js'

  export default {
    name: 'app',
    data() {
      return {
        isWindowsAio: false,
      }
    },
    computed: {
      styleObject() {
        return {
          paddingTop: this.$store.state.contentMarginTop + 'px',
          paddingBottom: this.$store.state.contentMarginBottom + 'px'
        }
      }
    },
    components: {
      indexHead,
      contentPage,
      indexFooter,
      zoomImg
    },
    created() {
      const search = utils.getSearch();
      const {from = ''} = search;
      const isWindowsAio = from.toLocaleUpperCase() === 'windowsAio'.toLocaleUpperCase();
      this.isWindowsAio = isWindowsAio;
    }
  };
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import './assets/less/base.less';

  #app {
    padding: 0;
    background: center center no-repeat;
    background-size: cover;
    overflow: hidden;
    .indexContentBg;
  }
</style>
<style rel="stylesheet/less" lang="less">
  .windows-aio {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }
    /*滑道*/
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px #333;
      border-radius: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?a5951e14